import { faCreditCard, faExternalLink } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FC } from "react";
import { FormattedMessage } from "react-intl"
import { connect } from "react-redux";
import { ReduxState, User } from "types";


export const PARKING_CARDS_URL_DEV = 'https://dev-parking-cards.parkd.com/';
export const PARKING_CARDS_URL_PROD = 'https://parking-cards.parkd.com/';

export const getParkingCardsURL = (user: User) => {
    const baseURL = import.meta.env.VITE_ENVIRONMENT === 'prod'
        ? PARKING_CARDS_URL_PROD
        : PARKING_CARDS_URL_DEV;

    const { locale, email, phoneNumber, givenName, familyName } = user;

    const encodedEmail = encodeURIComponent(email);
    const phoneTrimmed = phoneNumber?.replaceAll(' ', '');
    const encodedPhone = encodeURIComponent(phoneTrimmed);

    return `${baseURL}?locale=${locale}&email=${encodedEmail}&firstName=${givenName}&lastName=${familyName}&phone=${encodedPhone}`;
}


export const ParkingCards: FC<Props> = ({ user }: { user: User | null }) => (
    <div className="radius-rectangle settings-box">
        <div className="settings-box-header">
            <h3 className="bold-title">
                <FontAwesomeIcon icon={faCreditCard} className="icon-before" />
                <FormattedMessage id="PARKD_PARKING_CARDS_TITLE" />
            </h3>
        </div>

        <div className="settings-box-content">

            <p style={{ marginBottom: '1em' }}>
                <FormattedMessage
                    id="PARKD_PARKING_CARDS_DESCRIPTION"
                    values={{
                        a: chunks => (
                            <a
                                className="text-link"
                                href="mailto:support@parkd.com"
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>

            <a href={getParkingCardsURL(user!)} target="_blank" rel="noopener noreferrer" className="btn-blue">
                <FontAwesomeIcon icon={faExternalLink} style={{ marginRight: '0.5em' }} />
                <FormattedMessage id="PARKD_PARKING_CARDS_BTN" />
            </a>

        </div>
    </div>
)

type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps;

function mapStateToProps(state: ReduxState) {
    return {
        user: state?.user?.user,
    };
}

export default connect(mapStateToProps, null)(ParkingCards);